import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7bbe2df0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Soumettre un devoir", -1))
const _hoisted_4 = { class: "row mb-20" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group mb-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de soumission ", -1))
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Composition "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_13 = { class: "d-flex align-items-start gap-3" }
const _hoisted_14 = { class: "flex-grow-1" }
const _hoisted_15 = { class: "fw-bold mb-1" }
const _hoisted_16 = { class: "text-muted small" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book me-1" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "•", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-graduation-cap me-1" }, null, -1))
const _hoisted_20 = { class: "flex-shrink-0 align-self-center" }
const _hoisted_21 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times-circle me-1" }, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "badge bg-warning text-dark"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o me-1" }, null, -1))
const _hoisted_25 = {
  key: 2,
  class: "badge bg-success"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle me-1" }, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "alert alert-warning mt-2 py-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Aucune composition de type Questions/Réponses n'est disponible pour le moment.", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "text-muted mt-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin me-1" }),
  /*#__PURE__*/_createTextVNode(" Chargement des compositions...")
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }, null, -1))
const _hoisted_36 = {
  key: 0,
  class: "badge bg-danger ms-2"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }, null, -1))
const _hoisted_38 = {
  key: 1,
  class: "badge bg-warning text-dark ms-2"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o me-1" }, null, -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "mb-2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Titre :", -1))
const _hoisted_44 = { class: "mb-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Matière :", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Type :"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-success" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-text-o me-1" }),
    /*#__PURE__*/_createTextVNode("Questions/Réponses ")
  ])
], -1))
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "mb-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Filière :", -1))
const _hoisted_50 = { class: "mb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Niveau :", -1))
const _hoisted_52 = { class: "mb-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date de composition :", -1))
const _hoisted_54 = { class: "mb-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date limite :", -1))
const _hoisted_56 = {
  key: 0,
  class: "alert alert-danger mt-3 mb-0"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ban me-2" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cette composition est expirée.", -1))
const _hoisted_59 = {
  key: 1,
  class: "alert alert-warning mt-3 mb-0"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Attention !", -1))
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-12" }
const _hoisted_64 = { class: "form-group mb-20" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Fichier PDF du devoir "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_66 = {
  key: 0,
  class: "upload-placeholder"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cloud-upload fa-3x text-primary mb-3" }, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cliquez pour sélectionner un fichier PDF")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "ou glissez-déposez votre fichier ici", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "Taille maximale : 20 Mo", -1))
const _hoisted_71 = [
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = {
  key: 1,
  class: "file-preview"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o fa-3x text-danger mb-2" }, null, -1))
const _hoisted_74 = { class: "mb-1" }
const _hoisted_75 = { class: "text-muted small" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1))
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12" }
const _hoisted_79 = { class: "d-flex align-items-center gap-2" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_82 = {
  key: 1,
  class: "fa fa-paper-plane me-2"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Form, {
        ref: "devoirForm",
        onSubmit: _ctx.submitDevoir,
        "validation-schema": _ctx.devoirSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control bg-light text-muted",
                    value: _ctx.formatDate(_ctx.today),
                    disabled: "",
                    style: {"cursor":"not-allowed"}
                  }, null, 8, _hoisted_9)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, { name: "composition" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.compositionsOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onCompositionChange,
                      placeholder: "Sélectionner une composition",
                      disabled: _ctx.compositionsOptions.length === 0,
                      canDeselect: false,
                      classes: {
                    option: 'multiselect-option-custom',
                    optionDisabled: 'multiselect-option-disabled'
                  }
                    }), {
                      option: _withCtx(({ option }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['composition-option', { 'expired': option.estExpire, 'urgent': !option.estExpire && option.joursRestants <= 3 }])
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(option.titre), 1),
                              _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createTextVNode(_toDisplayString(option.matiere) + " ", 1),
                                _hoisted_18,
                                _hoisted_19,
                                _createTextVNode(_toDisplayString(option.filiere) + " - " + _toDisplayString(option.niveau), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              (option.estExpire)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                    _hoisted_22,
                                    _createTextVNode("Expiré ")
                                  ]))
                                : (option.joursRestants <= 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                      _hoisted_24,
                                      _createTextVNode(_toDisplayString(option.joursRestants) + "j ", 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                      _hoisted_26,
                                      _createTextVNode(_toDisplayString(option.joursRestants) + "j ", 1)
                                    ]))
                            ])
                          ])
                        ], 2)
                      ]),
                      _: 2
                    }, 1040, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "composition",
                  class: "text-danger"
                }),
                (_ctx.compositionsOptions.length === 0 && !_ctx.isLoadingCompositions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
                  : _createCommentVNode("", true),
                (_ctx.isLoadingCompositions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.selectedComposition)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['alert mb-20', _ctx.selectedComposition.estExpire ? 'alert-danger' : 'alert-info'])
              }, [
                _createElementVNode("h6", _hoisted_34, [
                  _hoisted_35,
                  _createTextVNode("Détails de la composition "),
                  (_ctx.selectedComposition.estExpire)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _hoisted_37,
                        _createTextVNode("EXPIRÉ ")
                      ]))
                    : (_ctx.selectedComposition.joursRestants <= 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                          _hoisted_39,
                          _createTextVNode("Urgent - " + _toDisplayString(_ctx.selectedComposition.joursRestants) + " jour(s) restant(s) ", 1)
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("p", _hoisted_42, [
                      _hoisted_43,
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedComposition.titre), 1)
                    ]),
                    _createElementVNode("p", _hoisted_44, [
                      _hoisted_45,
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedComposition.matiere), 1)
                    ]),
                    _hoisted_46
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("p", _hoisted_48, [
                      _hoisted_49,
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedComposition.filiere), 1)
                    ]),
                    _createElementVNode("p", _hoisted_50, [
                      _hoisted_51,
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedComposition.niveau), 1)
                    ]),
                    _createElementVNode("p", _hoisted_52, [
                      _hoisted_53,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.selectedComposition.dateComposition)), 1)
                    ]),
                    _createElementVNode("p", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.selectedComposition.estExpire ? 'text-danger fw-bold' : '')
                      }, _toDisplayString(_ctx.formatDate(_ctx.selectedComposition.dateFinSoumission || _ctx.selectedComposition.dateComposition)), 3)
                    ])
                  ])
                ]),
                (_ctx.selectedComposition.estExpire)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _hoisted_57,
                      _hoisted_58,
                      _createTextVNode(" Vous ne pouvez plus soumettre de devoir. ")
                    ]))
                  : (_ctx.selectedComposition.joursRestants <= 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _hoisted_60,
                        _hoisted_61,
                        _createTextVNode(" Il ne reste que " + _toDisplayString(_ctx.selectedComposition.joursRestants) + " jour(s) pour soumettre votre devoir. ", 1)
                      ]))
                    : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", {
                  class: _normalizeClass(["upload-area", { 'has-file': _ctx.selectedFile }]),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                }, [
                  _createElementVNode("input", {
                    type: "file",
                    ref: "fileInput",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                    accept: ".pdf",
                    style: {"display":"none"}
                  }, null, 544),
                  (!_ctx.selectedFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_71))
                    : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _hoisted_73,
                        _createElementVNode("p", _hoisted_74, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.selectedFile.name), 1)
                        ]),
                        _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.formatFileSize(_ctx.selectedFile.size)), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-danger mt-2",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)), ["stop"]))
                        }, [
                          _hoisted_76,
                          _createTextVNode(" Supprimer ")
                        ])
                      ]))
                ], 2),
                _createVNode(_component_ErrorMessage, {
                  name: "fichier",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting || !_ctx.selectedFile || !_ctx.selectedComposition || _ctx.selectedComposition?.estExpire
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_81))
                    : (_openBlock(), _createElementBlock("i", _hoisted_82)),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Soumission en cours...' : 'Soumettre le devoir'), 1)
                ], 8, _hoisted_80),
                _createVNode(_component_router_link, {
                  to: "/mes-devoirs",
                  class: "btn btn-secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_83,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}